export default function getLocationSelectionEvent(event, location, onMarkerClick) {
  event.preventDefault();
  event.stopPropagation();
  onMarkerClick(location);
  document.getElementById('tab0')?.click();
}
